import React, { useState, useEffect, useCallback } from 'react'
import { reduxForm } from 'redux-form'

import { signUpStepsData } from 'components/modals/v2/auth/sign_up_additional_details_modal/helpers/signup_steps_helper'
import SignUpLogoContent from 'components/modals/v2/auth/sign_up_logo_modal/components/sign_up_logo_content'
import useLabel from 'components/modals/v2/auth/sign_up_logo_modal/hooks/use_label'
import { validateUserAvatar } from 'components/modals/v2/auth/sign_up_logo_modal/helpers/validateUserAvatar'
import ImageHelpers from 'helpers/image_helpers'
import UserHelpers from 'helpers/user_helpers'
import AuthHelper from 'helpers/auth_helper'

const accept = '.png, .jpg, .jpeg'
const AvatarUpdateModal = ({ modalProps = {}, onClose, handleSubmit, ...props }) => {
  const [error, setError] = useState('')
  const isSubmitDisabled = props.invalid || props.submitting || props.pristine
  const label = useLabel()

  const onSubmit = useCallback(
    async ({ image }) => {
      const res = await ImageHelpers.uploadImageSimple(image.originalBase64)
      const croppedURL = ImageHelpers.cropUrl(res.secure_url, image.crop)

      UserHelpers.editUser(
        AuthHelper.logged_in_profileID,
        { avatar: croppedURL },
        (res) => {
          AuthHelper.setCurrentLoggedInUser(JSON.stringify(res.user))
          if (modalProps.onSuccess) modalProps.onSuccess(croppedURL)
          AuthHelper.loadFromBackend()
          onClose()
        },
        (err) => {
          console.error(err)
          setError('Oops, something went wrong')
        }
      )
    },
    [modalProps.onSuccess, onClose]
  )

  useEffect(() => {
    props.reset()
  }, [])

  return (
    <SignUpLogoContent
      allowLater={false}
      closable={true}
      onClose={onClose}
      error={error}
      accept={accept}
      label={label}
      isSubmitDisabled={isSubmitDisabled}
      onSubmit={handleSubmit(onSubmit)}
    />
  )
}

export default reduxForm({
  form: 'avatarUpdateModal',
  validate: validateUserAvatar,
  initialValues: { [signUpStepsData.imagePostpone.field]: false },
})(AvatarUpdateModal)
